import React from "react";
import { FlaskConical, Play, Loader2 } from "lucide-react";
import { Button } from "@shadcn-in-nx/ui/button";
import { useTranslation } from "react-i18next";

function TestingHeader({ onRunAll, isRunning, testCount }) {
    const { t } = useTranslation();

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <FlaskConical className="w-5 h-5 text-gray-600" />
                    <h2 className="text-lg font-semibold text-gray-900">
                        {t("testing.aiTesting") || "AI Testing"}
                    </h2>
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                        Beta
                    </span>
                </div>
                <div className="flex items-center gap-2">
                    <Button
                        onClick={onRunAll}
                        disabled={isRunning || testCount === 0}
                        size="sm"
                        className="gap-1"
                    >
                        {isRunning ? (
                            <Loader2 className="w-4 h-4 animate-spin" />
                        ) : (
                            <Play className="w-4 h-4" />
                        )}
                        {isRunning
                            ? t("testing.running") || "Running..."
                            : t("testing.runAll") || "Run All"}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default TestingHeader;
